import React from "react";

import styles from "./FilterWrapper.module.scss";

export function FilterWrapper({ children }) {
  return <div className={styles.filter_wrapper}>{children}</div>;
}
